export default __webpack_public_path__ + "static/media/activeDarkgreenMarker.f09e57f2.svg";